import React, { useState, useEffect } from "react";
import { createMuiTheme, withStyles, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useAuth0 } from "../../react-auth0-spa";
import config from '../../api_config.json';
import AppLoader from '../AppLoader'
import './Bookings.css';
import Badge from '@material-ui/core/Badge';
import { green } from '@material-ui/core/colors';
import ReplayIcon from '@material-ui/icons/Replay';
import { format, addMonths } from 'date-fns'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography';
import get from 'lodash.get';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import CalendarIcon from '@material-ui/icons/InsertInvitation';
import ScheduleIcon from '@material-ui/icons/Schedule';
import EventBusyIcon from '@material-ui/icons/EventBusy';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Chip from '@material-ui/core/Chip';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import Fab from '@material-ui/core/Fab';

const Link1 = React.forwardRef((props, ref) => <RouterLink innerRef={ref} {...props} />);

const theme = createMuiTheme({
  palette: {
    primary: green,
  },
});

const StyledTableRow = withStyles(theme => ({
  root: {
    '&.cancelled': {
      backgroundColor: 'rgba(217, 83, 79, 0.3)',
      'text-decoration': 'line-through'
    },
    '&.rescheduled': {
      backgroundColor: 'rgba(255, 204, 0, 0.3)',
      'text-decoration': 'line-through'
    },  
  },
}))(TableRow);

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    'box-shadow': '0px 0px 5px rgba(0,0,0,0.3)'
  },
  table: {
    minWidth: 650,
  },
  title: {
    color: '#003087',
    margin: theme.spacing(1)
  },
  divider: {
    color: '#003087',
    'margin-top': theme.spacing(3),
    'margin-bottom': theme.spacing(6)
  },
  menuLink: {
    color: '#000000',
    'text-decoration': 'none',
    '&:hover': {
      'text-decoration': 'none'
    }
  },
  badge: {
    margin: theme.spacing(3),
  },
  bookNowTitle: {
    color: '#003087',
    'margin-top': theme.spacing(10),
  },
  bookNowBtn: {
    marginTop: theme.spacing(8),
    color: '#ffffff',
  },
  bookNowIcon: {
    marginRight: theme.spacing(1),
  },
}));

function CancelledLessonActions(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        <HelpOutlineIcon />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>
          <p>This lesson has been cancelled.</p>
        </MenuItem>
      </Menu>
    </div>
  );
}

function RescheduledLessonActions(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        <HelpOutlineIcon />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>
          <p>This lesson has been rescheduled.</p>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <p>New lesson date: <strong>{props.newBookingDate}</strong></p>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <p>New lesson time: <strong>{props.newBookingTime}</strong></p>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <p>New lesson ref: {props.newBookingRef}</p>
        </MenuItem>
      </Menu>
    </div>
  );
}

function LessonActions(props) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        <MoreVertIcon />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>
          <a href={`https://calendly.com/julieth-spanish/general-spanish/invitees/${props.id}`} target="_blank" className={classes.menuLink} rel="noopener noreferrer">
            <ListItemIcon>
              <ScheduleIcon fontSize="small" />
            </ListItemIcon>
            <Typography variant="inherit">View</Typography>
          </a>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <a href={`https://calendly.com/reschedulings/${props.id}`} target="_blank" className={classes.menuLink} rel="noopener noreferrer">
            <ListItemIcon>
              <ScheduleIcon fontSize="small" />
            </ListItemIcon>
            <Typography variant="inherit">Reschedule</Typography>
          </a>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <a href={`https://calendly.com/cancellations/${props.id}`} target="_blank" className={classes.menuLink} rel="noopener noreferrer">
            <ListItemIcon>
              <EventBusyIcon fontSize="small" />
            </ListItemIcon>
            <Typography variant="inherit">Cancel</Typography>
          </a>
        </MenuItem>
      </Menu>
    </div>
  );
}

export default function Bookings() {
  const classes = useStyles();
  const [ loading, setLoading ] = useState(true);
  const [ hasApiIssue, setHasApiIssue ] = useState(false);
  const { isAuthenticated } = useAuth0();
  const [ items, setItems ] = useState([]);
  const [ upcomingTotal, setUpcomingTotal ] = useState(0);

  const { getTokenSilently } = useAuth0();

  useEffect(() => {
    const getFutureBookings = async () => {
      try {
        const token = await getTokenSilently();

        const now = new Date();
        const to = format(addMonths(now, 24), 'yyyy-MM-dd');
        const from = format(now, 'yyyy-MM-dd');

        const url = `${config.apiUrl[process.env.REACT_APP_ENV]}/bookings?from=${from}&to=${to}`;
        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        const responseData = await response.json();

        const rows = [];

        responseData.data = responseData.data.map(item => {
          if(item.event_status === 'rescheduled') {
            const newBooking = responseData.data.find(e => e.eventId === item.new_event_uuid);
            item.new_booking_data = newBooking;
          }

          return item
        });

        // Sort the lesson by date (asc)
        responseData.data = responseData.data.sort((a, b) => a.timestamp - b.timestamp);

        responseData.data.map(booking => {
          const lesson_date_pretty = format(new Date(booking.lesson_start_time), "E, LLL d");
          const lesson_time_pretty = format(new Date(booking.lesson_start_time), "HH:mm") + ' - ' + format(new Date(booking.lesson_end_time), "HH:mm a");

          Object.assign(booking, { lesson_date_pretty, lesson_time_pretty });

          // This is a rescheduled, we can make pretty dates 
          if (booking.new_booking_data) {
            const new_lesson_date_pretty = format(new Date(booking.new_booking_data.lesson_start_time), "E, LLL d");
            const new_lesson_time_pretty = format(new Date(booking.new_booking_data.lesson_start_time), "HH:mm") + ' - ' + format(new Date(booking.new_booking_data.lesson_end_time), "HH:mm a");
  
            Object.assign(booking, { new_lesson_date_pretty, new_lesson_time_pretty });
          }

          rows.push(booking)

          return booking;
        });

        return responseData.data;
      } catch (error) {
        console.error(error);
      }
    };

    getFutureBookings().then(data => {
      setLoading(false);
      setItems(data);

      // I count the upcoming lessons
      const total = data.reduce((acc, lesson) => {
        if (lesson.event_status === 'scheduled') {
          acc = acc + 1;
        }

        return acc;
      }, 0)

      setUpcomingTotal(total);
    }).catch(error => {
      setHasApiIssue(true);
    })
  }, [getTokenSilently])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  if (loading) {
    return <AppLoader />
  }

  if (!isAuthenticated) {
    return <div></div>;
  }

  if (hasApiIssue) {
    return (
      <Container maxWidth="lg">
        <Typography variant="h4" gutterBottom className={classes.bookNowTitle}>Oops. Something went wrong.</Typography>
        <Typography variant="h4" gutterBottom className={classes.title}>Cannot fetch lessons data. Please report the issue or try again <span aria-label="teacher" role="img">🤦‍♀️</span></Typography>
        <a href={config.siteUrl[process.env.REACT_APP_ENV]} className={classes.menuLink}>
          <ThemeProvider theme={theme}>
            <Fab variant="extended" color="primary" aria-label="like" className={classes.bookNowBtn}>
              <ReplayIcon className={classes.bookNowIcon} />
              Try again
            </Fab>
          </ThemeProvider>
        </a>
      </Container>
    )
  }

  if (upcomingTotal === 0) {
    return (
      <Container maxWidth="lg">
        <Typography variant="h4" gutterBottom className={classes.bookNowTitle}>No lessons scheduled yet.</Typography>
        <Typography variant="h4" gutterBottom className={classes.title}>Would you like to book one? <span aria-label="teacher" role="img">👩‍🏫</span></Typography>
        <Link component={Link1} to="/book-lesson" className={classes.menuLink}>
          <ThemeProvider theme={theme}>
            <Fab variant="extended" color="primary" aria-label="like" className={classes.bookNowBtn}>
              <CalendarIcon className={classes.bookNowIcon} />
              Book now
            </Fab>
          </ThemeProvider>
        </Link>
      </Container>
    )
  }

  return (
    <Container maxWidth="lg">
      <Badge className={classes.badge} badgeContent={upcomingTotal} color="primary">
        <Typography variant="h4" gutterBottom className={classes.title}>Upcoming Lessons <span aria-label="teacher" role="img">👩‍🏫</span></Typography>
      </Badge>

      <Paper className={classes.root}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Lesson Type</TableCell>
              <TableCell align="right">Lesson Date</TableCell>
              <TableCell align="right">Lesson Time</TableCell>
              <TableCell align="right">Payment (USD)</TableCell>
              <TableCell align="right">Booking Ref.</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map(row => (
              <StyledTableRow key={row.eventId} className={row.event_status}>
                <TableCell component="th" scope="row">{row.event_name}</TableCell>
                <TableCell align="right">{row.lesson_date_pretty}</TableCell>

                <LightTooltip title={`This time is in your local timezone: ${row.timezone}`} TransitionComponent={Zoom} placement="bottom">
                  <TableCell align="right"><Chip label={row.lesson_time_pretty} /></TableCell>
                </LightTooltip>

                <LightTooltip title={`Payment Ref: ${get(row, 'payments[0].id', 'N/A')}`} TransitionComponent={Zoom} placement="bottom">
                  <TableCell align="right">{get(row, 'payments[0].amount', 0)}</TableCell>
                </LightTooltip>

                <TableCell align="right">{row.eventId}</TableCell>

                <TableCell align="right">
                  {row.event_status === 'scheduled' && <LessonActions id={row.invitee_uuid} />}
                  {row.event_status === 'rescheduled' && <RescheduledLessonActions newBookingRef={row.new_event_uuid} newBookingDate={row.new_lesson_date_pretty} newBookingTime={row.new_lesson_time_pretty} />}
                  {row.event_status === 'cancelled' && <CancelledLessonActions />}
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
}

